<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button variant="ghost" class="w-8 h-8 p-0">
        <span class="sr-only">Open menu</span>
        <MoreHorizontal class="w-4 h-4" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuItem :disabled="!user?.merchantRole" @click="emit('updateEdit', props.admin)">Edit</DropdownMenuItem>
      <DropdownMenuItem
        v-if="props.admin.active"
        :disabled="!user?.merchantRole"
        @click="emit('updateDeactivate', props.admin, false)"
      >
        Deactivate
      </DropdownMenuItem>
      <DropdownMenuItem
        v-if="!props.admin.active"
        :disabled="!user?.merchantRole"
        @click="emit('updateDeactivate', props.admin, true)"
      >
        Activate
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useUserStore } from '@/stores/users';
import { MoreHorizontal } from 'lucide-vue-next';
import { storeToRefs } from 'pinia';
import type { ModelUserResponse } from '@layup/api-sdk';

const props = defineProps<{ admin: ModelUserResponse }>();
const emit = defineEmits(['updateEdit', 'updateDeactivate']);
const userStore = useUserStore();
const { user } = storeToRefs(userStore);
</script>
